module.exports = __webpack_public_path__ + "static/04-171b7ea416f7276e9ad3d2ca262ec5c2.jpg";